import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringtoarr'
})
export class StringtoarrPipe implements PipeTransform {

  transform(value: string): any[] {
    if(value){
      let data=value.split(",");
    return (data);
    }
    else{
      return [];
    }
    
  }

}
